import api from "../config/axios";

// Get all pages
export const getAllPages = async () => {
  try {
    const response = await api.get("/admin/cms/pages");
    return response.data;
  } catch (error) {
    console.error("Error fetching pages:", error);
    throw error;
  }
};

// Get sections by page name
export const getSectionsByPage = async (pageName) => {
  try {
    const response = await api.get(`/admin/cms/pages/${pageName}/sections`);
    return response.data;
  } catch (error) {
    console.error("Error fetching sections:", error);
    throw error;
  }
};

// Get content by page name
export const getContentByPage = async (pageName) => {
  try {
    const response = await api.get(`/admin/cms/pages/${pageName}/content`);
    return response.data;
  } catch (error) {
    console.error("Error fetching content:", error);
    throw error;
  }
};

// Get content by page and section
export const getContentByPageAndSection = async (pageName, sectionName) => {
  try {
    const response = await api.get(`/admin/cms/pages/${pageName}/sections/${sectionName}/content`);
    return response.data;
  } catch (error) {
    console.error("Error fetching content:", error);
    throw error;
  }
};

// Get content by ID
export const getContentById = async (contentId) => {
  try {
    const response = await api.get(`/admin/cms/content/${contentId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching content:", error);
    throw error;
  }
};

// Create new content
export const createContent = async (contentData) => {
  try {
    const response = await api.post("/admin/cms/content", contentData);
    return response.data;
  } catch (error) {
    console.error("Error creating content:", error);
    throw error;
  }
};

// Update content
export const updateContent = async (contentId, contentData) => {
  try {
    const response = await api.put(`/admin/cms/content/${contentId}`, contentData);
    return response.data;
  } catch (error) {
    console.error("Error updating content:", error);
    throw error;
  }
};

// Delete content
export const deleteContent = async (contentId) => {
  try {
    const response = await api.delete(`/admin/cms/content/${contentId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting content:", error);
    throw error;
  }
};

// Toggle content status
export const toggleContentStatus = async (contentId) => {
  try {
    const response = await api.patch(`/admin/cms/content/${contentId}/toggle-status`);
    return response.data;
  } catch (error) {
    console.error("Error toggling content status:", error);
    throw error;
  }
};

// Get CMS statistics
export const getCmsStats = async () => {
  try {
    const response = await api.get("/admin/cms/stats");
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS stats:", error);
    throw error;
  }
};

// Get grouped content
export const getContentGrouped = async () => {
  try {
    const response = await api.get("/admin/cms/content-grouped");
    return response.data;
  } catch (error) {
    console.error("Error fetching grouped content:", error);
    throw error;
  }
};
